
<div class="row jobs" *ngIf="totalCount>0">
  <div class="col-sm-12 col-lg-4 col-md-12 ps-0 infinite-scroll" infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
  [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngFor="let job of jobsList;">
      <div class="card-grid-2" [ngClass]="{'active':jobID == job?.id }">
        <app-details-job-item [job]="job" (onJobSaved)="saveUnsaveJob($event,1);"
          (click)="goToJobDetail(job?.id)"></app-details-job-item>
      </div>
    </div>
  </div>

  <div *ngIf="jobDetailsData" class="col-sm-12 col-lg-8 col-md-8 jobDetails">
    <div class="jobDesp">
      <div class="card-grid-2">
        <div class="card-grid-2-image-left">
          <div class="jobsdiv">
            <div class="image-box">
              <img src="{{jobDetailsData?.recruiter?.profileImage != null ? recruiterImagePath : ''}}{{jobDetailsData?.recruiter?.profileImage != null ? jobDetailsData?.recruiter?.profileImage : 'assets/images/profile-img.jpg' }}" alt="jobBox">
            </div>
            <div class="right-info">
              <a class="name-job">{{jobDetailsData?.recruiter?.companyName}}
                <span *ngIf="jobDetailsData?.JobPost?.isfeatured == 1" class="featured">Featured</span>
              </a>
              <!-- <span class="location-small">{{jobDetailsData?.workPlaceLocation}}</span> -->
              <span class="location-small" *ngIf="jobDetailsData?.JobPost?.workPlaceLocation != 'Remote'">{{jobDetailsData?.JobPost?.location || "NA"}}</span>
                      <span class="location-small" *ngIf="jobDetailsData?.JobPost?.workPlaceLocation == 'Remote'">Remote</span>
            </div>
          </div>
          <div class="apply">
            <img
              src="{{jobDetailsData?.JobPost?.saveStatus == 0 ?  'assets/images/ic_unsave.svg':'assets/images/saved_job.svg'}}"
              alt="unsave" (click)="saveUnsaveJob(jobDetailsData.JobPost,2);$event.stopPropagation()">
            <a *ngIf="jobDetailsData?.JobPost?.isApplyed == 1" class="applybtn borderBtn" routerLink="/chat" [queryParams]="{'id':jobDetailsData.JobPost.id}">Message</a>
            <a *ngIf="jobDetailsData?.JobPost?.isApplyed == 1" (click)="withdrawJob(jobDetailsData?.JobPost?.id)"
              class="applybtn borderBtn fill">Withdraw</a>
            <a *ngIf="jobDetailsData?.JobPost?.isApplyed == 0" (click)="applyJob(jobDetailsData?.JobPost?.id)"
              class="applybtn borderBtn fill">Apply</a>
          </div>
        </div>
      </div>
      <!-- row -->

      <!-- End -->
      <div class="card-block-inner p-0">
        <h6>{{jobDetailsData?.JobPost?.jobTitle}}</h6>
      </div>
      <div class="row m-0">
        <div class="col-sm-6 descrpinner">
          <span>
            <!-- <img src="assets/images/ic_price.svg"> -->
            {{jobSalary(jobDetailsData?.JobPost)}}
          </span>
        </div>
        <div class="col-sm-6 descrpinner">
          <span><img src="assets/images/ic_applicant.svg">{{jobDetailsData?.JobPost?.applicantsCount}} applicants</span>
        </div>
        <div class="col-sm-6 descrpinner">
          <span><img src="assets/images/ic_clock.svg">{{jobDetailsData?.JobPost?.schedulesName}}</span>
        </div>
        <div class="col-sm-6 descrpinner">
          <span><img src="assets/images/ic_jobtime.svg">{{jobDetailsData?.JobPost?.EmploymentTypesName}}</span>
        </div>
      </div>
      <div class=" col-sm-12 cards-inner2">
        <span class="card-time">Job start date: {{jobDetailsData?.JobPost?.createdAt | date }} </span> |
        <span class="card-applicants">Posted: {{dateInMilisecond(jobDetailsData?.JobPost?.createdAt) | dateAgoConvertor}}</span>
      </div>
    </div> <!--Inner row end  -->
    <!-- end -->
    <div class="innerdes">
      <h6 class="heading-6">Job description</h6>
      <ul class="jobdeslist">
        <li><img src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.description || "NA"}}</li>
      </ul>
    </div>
    <div class="innerdes" *ngIf="jobDetailsData?.JobPostSkills.length > 0">
      <h6 class="heading-6">Skills</h6>
      <ul class="addedskills">
        <li *ngFor="let skill of jobDetailsData?.JobPostSkills">{{skill?.skillsName}}</li>
      </ul>
    </div>
    <div class="innerdes" *ngIf="jobDetailsData?.JobPostBenefits.length > 0">
      <h6 class="heading-6">Benefits</h6>
      <ul class="addedskills">
        <li *ngFor="let benefit of jobDetailsData?.JobPostBenefits">{{benefit?.benefitsName}}</li>
      </ul>
      <ul class="addedskills" *ngIf="jobDetailsData?.JobPostBenefits.length == 0">NA</ul>
    </div>
    <div class="innerdes" *ngIf="jobDetailsData?.supplementalPay.length > 0">
      <h6 class="heading-6">Supplemental pay</h6>
      <ul class="addedskills">
        <li *ngFor="let pay of jobDetailsData?.supplementalPay">{{pay?.supplements_name}}</li>
      </ul>
      <ul class="addedskills" *ngIf="jobDetailsData?.supplementalPay.length == 0">NA</ul>
    </div>
    <div class="innerdes">
      <h6 class="heading-6">Number of positions</h6>
      <ul class="jobdeslist">
        <li><img src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.noOfPeopleRequired || "NA"}}</li>
      </ul>
    </div>
    <div class="innerdes">
      <h6 class="heading-6">Must Haves</h6>
      <ul class="jobdeslist">
        <li><img src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.vaccinationCerificate == 1 ?
          "Covid-19 vaccination certificate required" : "Covid-19 vaccination certificate not
          required"}}</li>
        <li *ngIf="jobDetailsData?.JobPost?.travelRequirementsName"><img
            src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.travelRequirementsName}}</li>
      </ul>
    </div>
  </div>
</div>


<div class="noDataFound" *ngIf="totalCount==0">
  <h2>No Records Found</h2>
</div>